import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { useHistory, useLocation } from 'react-router-dom';
import { useConfiguration } from '../../context/configurationContext';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { useIntl, FormattedMessage } from '../../util/reactIntl';
import { getListingsById } from '../../ducks/marketplaceData.duck';
import { searchListings } from './FeaturedWorkshops.duck';

import { ListingCard } from '../../components';

import css from './FeaturedWorkshops.module.css';

const FeaturedWorkshopsComponent = props => {
  const { currentUser, listingType, onFetchListings, listings, searchInProgress, searchListingsError } = props;

  useEffect(() => {
    onFetchListings({ listingType });
  }, [])

  const cardRenderSizes = () => {
    const panelMediumWidth = 50;
    const panelLargeWidth = 62.5;
    return [
      '(max-width: 767px) 100vw',
      `(max-width: 1023px) ${panelMediumWidth}vw`,
      `(max-width: 1920px) ${panelLargeWidth / 2}vw`,
      `${panelLargeWidth / 3}vw`,
    ].join(', ');
  };

  return (
    <div className={css.root}>

      {searchInProgress && (
        <div className={css.loading}>
          <IconSpinner />
        </div>
      )}

      {!searchInProgress && !!listings?.length &&
        <div className={css.listingsHolder}>
          {listings.map(l => (
            <ListingCard
              className={css.listingCard}
              key={l.id.uuid}
              listing={l}
              renderSizes={cardRenderSizes()}
              setActiveListing={() => { }}
              styleTheme='dark'
              showButton
              showLocationAndDate
            />
          ))}
        </div>
      }

      {/* {searchListingsError && (
        <div>
          error
        </div>
      )} */}
    </div>
  );
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const {
    currentPageResultIds,
    searchInProgress,
    searchListingsError
  } = state.FeaturedWorkshops;

  const listings = getListingsById(state, currentPageResultIds);

  return {
    currentUser,
    listings
  };
};

const mapDispatchToProps = dispatch => ({
  onFetchListings: params => dispatch(searchListings(params)),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const FeaturedWorkshops = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(FeaturedWorkshopsComponent);

export default FeaturedWorkshops;
